import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetMeRequest, UseGetMeData, UseGetNotificationSettingsRequest, UseGetNotificationSettingsData } from "@api/@types/me";

export const useGetMe = createApiQuery<UseGetMeData, UseGetMeRequest>({
  queryKey: () => ["getMe", "all"],
  queryFn: (req) => apiClientManager.apis.me.getMe(req as UseGetMeRequest),
  extractData: (res) => res.data.data as UseGetMeData,
  isEnabled: () => true,
});

export const useGetNotificationSettings = createApiQuery<UseGetNotificationSettingsData, UseGetNotificationSettingsRequest>({
  queryKey: () => ["getNotificationSettings", "all"],
  queryFn: (req) => apiClientManager.apis.me.getNotificationSettings(req as UseGetNotificationSettingsRequest),
  extractData: (res) => res.data.data as UseGetNotificationSettingsData,
  isEnabled: () => true,
});

export type { UseGetMeRequest, UseGetMeData, UseGetNotificationSettingsRequest, UseGetNotificationSettingsData } from "@api/@types/me";
